export default __webpack_public_path__ + "static/media/suppliment_yellow.7d4044ab.svg";